import NutritionLayout from "./NutritionLayout";
import ketoDiet from "../images/keto-diet.jpg";
import mediterraneanDiet from "../images/mediterranean-diet.jpg";
import veganDiet from "../images/vegan-diet.jpg";
import paleoDiet from "../images/paleo-diet.png";
import intermittentFasting from "../images/intermittent-fasting.png";
import dashDiet from "../images/dash-diet.jpg";

const mealPlans = [
    {
        name: "Keto Diet",
        image: ketoDiet,
        description: "The ketogenic diet is a high-fat, low-carbohydrate approach that shifts your body into ketosis, burning fat for fuel instead of glucose. By keeping carbs under roughly 20–50 grams per day and emphasizing healthy fats—avocado, olive oil, nuts, and fatty fish—many people see benefits for weight loss, mental clarity, and metabolic health. Our plans include protein-focused, dairy-free, and vegetarian keto options so you can find a style that fits your preferences and lifestyle.",
        category: "keto"
    },
    {
        name: "Mediterranean Diet",
        image: mediterraneanDiet,
        description: "Inspired by the eating habits of coastal Greece, Italy, and Spain, the Mediterranean diet emphasizes vegetables, fruits, whole grains, legumes, olive oil, and moderate amounts of fish and poultry. It’s consistently linked to better heart health, longevity, and a lower risk of chronic disease—without strict rules or cutting entire food groups. Our meal sets range from traditional and coastal styles to garden-fresh options, so you can enjoy variety while eating the way the world’s healthiest populations do.",
        category: "mediterranean"
    },
    {
        name: "Vegan Diet",
        image: veganDiet,
        description: "A fully plant-based diet that excludes all animal products—meat, dairy, eggs, and honey—while focusing on whole grains, legumes, nuts, seeds, and plenty of fruits and vegetables. Going vegan can support heart health, digestion, and environmental sustainability, and with thoughtful planning it easily meets protein and nutrient needs. We’ve put together protein-powered, whole-foods, and international-flavor meal sets so you can build a satisfying, varied vegan routine.",
        category: "vegan"
    },
    {
        name: "Paleo Diet",
        image: paleoDiet,
        description: "The paleo approach centers on foods that could have been hunted or gathered: lean meats, fish, eggs, vegetables, fruits, nuts, and seeds, while avoiding grains, legumes, refined sugar, and most dairy. The idea is to eat the way our ancestors did—whole, unprocessed foods that support stable energy and reduce inflammation. Our plans include hunter-gatherer, seafood-focused, and plant-heavy paleo options so you can tailor meals to your taste and goals.",
        category: "paleo"
    },
    {
        name: "Intermittent Fasting",
        image: intermittentFasting,
        description: "Intermittent fasting isn’t about what you eat so much as when you eat: you cycle between periods of eating and fasting, which may support weight management, metabolic health, and even longevity. Popular methods include 16:8 (eating within an 8-hour window), 5:2 (two lighter days per week), and more advanced patterns like OMAD. We break down each approach with clear guidelines, sample windows, and tips so you can choose and stick to a method that fits your schedule and experience level.",
        category: "intermittent_fasting"
    },
    {
        name: "DASH Diet",
        image: dashDiet,
        description: "The Dietary Approaches to Stop Hypertension (DASH) diet was designed to help lower blood pressure by emphasizing fruits, vegetables, whole grains, lean proteins, and low-fat dairy while limiting sodium, saturated fat, and added sugars. It’s backed by research for heart health and is flexible enough to enjoy long term. Our meal sets—heart-healthy, blood-pressure-focused, and balanced—give you practical, flavorful ideas that align with DASH principles and support your cardiovascular goals.",
        category: "dash"
    }
];

function Nutrition() {
  return (
    <div className="page-container py-10 sm:py-12">
      <h1 className="page-heading">Nutrition Plans</h1>
      <div className="space-y-8 pb-16">
        {mealPlans.map((plan, index) => (
          <NutritionLayout
            key={index}
            name={plan.name}
            image={plan.image}
            description={plan.description}
            actionButton="View Details"
            actionLink={`/Nutrition/${plan.category}`}
          />
        ))}
      </div>
    </div>
  );
}
export default Nutrition;
